
@if (onlyNumber && config.fieldFormatter && config.fieldFormatter === 'decimal') {
  <div [formGroup]="group">
    <mat-form-field appearance="outline" class="basic-input-field" [ngClass]="config.class">
      <mat-label class="select-label">{{config.label}}</mat-label>
      <input matInput decimalConverter appBlockPaste appIosMinusButton placeholder="{{config.placeholder}}" id="{{config.id}}" [type]="config.inputType? config.inputType:'text'" [formControlName]="config.name"  [attr.name]="config.name" [attr.autocomplete]="config.autocomplete != undefined ? config.autocomplete : 'off'" [numbersOnly]="true" [formatter]="config.formatter" [ngClass]="config.inputClassName" (input)="onInputChange($event)">
      @if (config.hint) {
        <mat-hint [ngClass]="{'float-right d-block': config.hintRight}" [align]="end" >{{ config.hintText}}</mat-hint>
      }
      @if (group.controls[FormControlName].hasError('minlength') && config.showErrorText) {
        <mat-error>
          Min length validate 6
        </mat-error>
      }
      @if (group.controls[FormControlName].hasError('required') && group.controls[FormControlName].touched && config.showErrorText) {
        <mat-error>
          Field Required Field
        </mat-error>
      }
    </mat-form-field>
  </div>
}
@if (onlyNumber && !config.fieldFormatter) {
  <div [formGroup]="group">
    <mat-form-field appearance="outline" class="basic-input-field" [ngClass]="config.class">
      <mat-label class="select-label">{{config.label}}</mat-label>
      <input matInput appBlockPaste placeholder="{{config.placeholder}}" id="{{config.id}}" [type]="config.inputType? config.inputType:'text'" [formControlName]="config.name"  [attr.name]="config.name" [attr.autocomplete]="config.autocomplete != undefined ? config.autocomplete : 'off'" [numbersOnly]="true" [ngClass]="config.inputClassName">
      @if (config.hint) {
        <mat-hint [ngClass]="{'float-right d-block': config.hintRight}" [align]="end" >{{ config.hintText}}</mat-hint>
      }
      @if (group.controls[FormControlName].hasError('minlength') && config.showErrorText) {
        <mat-error>
          Min length validate 6
        </mat-error>
      }
      @if (group.controls[FormControlName].hasError('required') && group.controls[FormControlName].touched && config.showErrorText) {
        <mat-error>
          Field Required Field
        </mat-error>
      }
    </mat-form-field>
  </div>
}
@if (digitOnly) {
  <div [formGroup]="group">
    <mat-form-field appearance="outline" class="basic-input-field" [ngClass]="config.class">
      <mat-label class="select-label">{{config.label}}</mat-label>
      <input matInput appBlockPaste placeholder="{{config.placeholder}}" id="{{config.id}}" [type]="config.inputType? config.inputType:'text'" [formControlName]="config.name"  [attr.name]="config.name" [attr.autocomplete]="config.autocomplete != undefined ? config.autocomplete : 'off'" digitOnly>
      @if (config.hint) {
        <mat-hint [ngClass]="{'float-right d-block': config.hintRight}" [align]="end" >{{ config.hintText}}</mat-hint>
      }
      @if (group.controls[FormControlName].hasError('minlength') && config.showErrorText) {
        <mat-error>
          Min length validate 6
        </mat-error>
      }
      @if (group.controls[FormControlName].hasError('required') && group.controls[FormControlName].touched && config.showErrorText) {
        <mat-error>
          Field Required Field
        </mat-error>
      }
    </mat-form-field>
  </div>
}
@if (numbersDotOnly) {
  <div [formGroup]="group">
    <mat-form-field appearance="outline" class="basic-input-field" [ngClass]="config.class">
      <mat-label class="select-label">{{config.label}}</mat-label>
      <input matInput appBlockPaste placeholder="{{config.placeholder}}" id="{{config.id}}" [type]="config.inputType? config.inputType:'text'" [formControlName]="config.name"  [attr.name]="config.name" [attr.autocomplete]="config.autocomplete != undefined ? config.autocomplete : 'off'" numbersDotOnly>
      @if (config.hint) {
        <mat-hint [ngClass]="{'float-right d-block': config.hintRight}" [align]="end" >{{ config.hintText}}</mat-hint>
      }
      @if (group.controls[FormControlName].hasError('minlength') && config.showErrorText) {
        <mat-error>
          Min length validate 6
        </mat-error>
      }
      @if (group.controls[FormControlName].hasError('required') && group.controls[FormControlName].touched && config.showErrorText) {
        <mat-error>
          Field Required Field
        </mat-error>
      }
    </mat-form-field>
  </div>
}
@if (!numbersDotOnly && !digitOnly && !onlyNumber) {
  <div [formGroup]="group">
    <mat-form-field appearance="outline" class="basic-input-field" [ngClass]="config.class">
      <mat-label class="select-label">{{config.label}}</mat-label>
      <input matInput placeholder="{{config.placeholder}}" id="{{config.id}}" [type]="config.inputType? config.inputType:'text'" [formControlName]="config.name"  [attr.name]="config.name" [attr.autocomplete]="config.autocomplete != undefined ? config.autocomplete : 'off'">
      @if (config.hint) {
        <mat-hint [ngClass]="{'float-right d-block': config.hintRight}" [align]="end" >{{ config.hintText}}</mat-hint>
      }
      @if (group.controls[FormControlName].hasError('minlength') && config.showErrorText) {
        <mat-error>
          Min length validate 6
        </mat-error>
      }
      @if (group.controls[FormControlName].hasError('required') && group.controls[FormControlName].touched && config.showErrorText) {
        <mat-error>
          Field Required Field
        </mat-error>
      }
    </mat-form-field>
  </div>
}









